import React, { FC } from "react";
import TextInput from "./TextInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faXmark,
} from "@fortawesome/free-solid-svg-icons";

interface TextInputProps {
    value?: string;
    placeholder?: string;
    disabled?: boolean;
    handleUpdate?: (value: string) => void;
}

const SearchTextInput: FC<TextInputProps> = ({
    value = "",
    placeholder = "",
    disabled = false,
    handleUpdate = () => {},
}) => {
    return (
        <div className="flex flex-row">
            <div className="flex-1 min-w-0">
                <TextInput
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    handleUpdate={handleUpdate}
                />
            </div>
            <div>
                <button
                    className={`border px-2 py-1 rounded-md text-white bg-gray-800 ${!value ? "invisible" : ""}`}
                    onClick={() => handleUpdate("")}
                >
                    <FontAwesomeIcon icon={faXmark} size="1x" className="text-white"/>
                </button>
            </div>
        </div>
    );
};

export default SearchTextInput;
